import React, { Dispatch, SetStateAction, useState } from 'react';
import { PopupOrPanel } from '../../../components/popupsAndPanels/PopupAndPanels';
import { Spinner } from 'components/spinner/Spinner';
import { WondeApi } from 'api/wondeApi';
import { useToast } from 'hooks/useToast';
import { EMAIL_ERROR_MSG } from '../wISteps/WIStep3';

export type SelectedRecord = {
  dynamicFilters: null;
  howManyResults: number;
  wondeschoolusers__emailaddress: string;
  wondeschoolusers__id: number;
  wondeschoolusers__name: string;
};

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  recordsSelected: SelectedRecord[];
  setCurrentStep: Dispatch<SetStateAction<number>>;
  currentSubmitUrl: string;
  currentSynOpt: string;
  tableData: any;
  setCreateErrors: React.Dispatch<React.SetStateAction<number[] | null>>
};

export const CreateRecordsPopup: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  recordsSelected,
  setCurrentStep,
  currentSubmitUrl,
  currentSynOpt,
  tableData,
  setCreateErrors
}) => {
  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const successToast = useToast("Successfully submitted");

  const closeModal = () => {
    setError('')
    togglePanelOpen(false)
  };

  const submitRecordOpts = async (selected_items: SelectedRecord[]) => {
    setIsSubmitting(true);

    const selectedIds = currentSynOpt === "Class" ? 
      { unmatchedClasses: selected_items.map((item: any) => item.wondeclasses__id) } : 
      { unmatchedPupils: selected_items.map((item: any) => item.wondepupils__id) };

    const result = await WondeApi.submitSelectedWondeRecords(selectedIds, currentSubmitUrl);

    if (!result.error) {
      successToast();
      window.scrollTo(0, 0);
      setCurrentStep(4);
    }
    if (result.error) {
      if (
        result.error.formErrors &&
        result.error.formErrors.length > 0 &&
        result.error.formErrors.find(
          (err) => err.messageCode === 'Invalid_EmailAddresses'
        )
      ) {
        const errorsIndexs: (number|null)[] = result.error.formErrors.map(err => {
          const match = err.fieldName.match(/\[(\d+)\]/);
          return match ? parseInt(match[1]) : null;
        }).filter(num => typeof num === 'number')
        const errorIds = selected_items.filter((_, i) => errorsIndexs.includes(i)).map(item=>item.wondeschoolusers__id);
        setCreateErrors(errorIds);
        setIsSubmitting(false);
        setError(`${EMAIL_ERROR_MSG}`);
      } else {
        setError('An error occurred, please try again.');
        setIsSubmitting(false);
      }
    }  
  };  

  const isEmailError = error === `${EMAIL_ERROR_MSG}`;

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={"Create Records"}
      position="right"
      givenClass="WondeCreateRecords"
      noFooter={false}
      primaryBtnTxt={isEmailError ? 'Close' : "Confirm"}
      secondaryBtnTxt="Cancel"      
      handleClose={closeModal}
      handlePrimaryBtn={() => {
        if (isEmailError) {
          closeModal();
        } else if(recordsSelected.length > 0){
          submitRecordOpts(recordsSelected);
        } else {
          window.scrollTo(0, 0);
          setCurrentStep(4);
        }
      }}
      handleSecondaryBtn={closeModal}
      width={460}
      isSubmitting={isSubmitting}
    >
      {error && <p className="GeneralError2">{error}</p>}

      {(!tableData || tableData.length <= 0) && <p>There are no records to create in Get Set.</p>}

      {tableData && tableData.length > 0 && recordsSelected.length <= 0 && <p>Are you sure you do not wish to create any additional records in Get Set?</p>}

      {recordsSelected.length > 0 && <p>Are you sure you want to create these records in Get Set?</p>}

      <div className="PopupRecordsList">
        {recordsSelected.map((item: any, index: number) => {
          return (
            <div className="RLItem" key={index}>- {currentSynOpt === "Class" ? 
                item.wondeclasses__classname :
                currentSynOpt === "Pupil" ?
                item.wondepupils__name :
                item.wondeschoolusers__name}
            </div>
          );
        })}
      </div>

      {isSubmitting && <Spinner color={'#f59e16'} /> }          
    </PopupOrPanel>
  );  
};